import type { Event as SentryEvent } from "@sentry/react"
import { ensurePosthogInitialized } from "../analytics/posthogClient.web"
import { posthogAppHost, posthogProjectId } from "../constants"

export function attachPosthogReplayToSentryEvent(event: SentryEvent): SentryEvent {
  try {
    const posthog = ensurePosthogInitialized()
    const sessionId = posthog.get_session_id()

    if (!sessionId) {
      return event
    }

    const replayUrl =
      posthog.sessionRecordingStarted() && typeof posthog.get_session_replay_url === "function"
        ? posthog.get_session_replay_url({ withTimestamp: true, timestampLookBack: 30 })
        : `${posthogAppHost}/project/${posthogProjectId}/replay/home?sessionRecordingId=${sessionId}`

    event.tags = {
      ...event.tags,
      posthog_replay: replayUrl,
      posthog_session_id: sessionId,
    }
  } catch {
    // PostHog may not be ready yet.
  }

  return event
}
